import styled from 'styled-components'

import { IconsQA } from 'shared/dataAttributes'

export const AfterPayLogo = () => {
  return (
    <CustomSvg
      data-qa={IconsQA.AfterPayIcon}
      width="48"
      height="32"
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="32" rx="2" fill="#B2FCE4" />
      <path
        d="M41.985 14.3462L40.8708 13.7087L39.7405 13.0614C38.9935 12.6331 38.0596 13.1709 38.0596 14.0339V14.1788C38.0596 14.2593 38.1015 14.3334 38.1723 14.372L38.6972 14.6715C38.8421 14.7552 39.0225 14.6489 39.0225 14.4815V14.1369C39.0225 13.9663 39.206 13.86 39.3541 13.9437L40.3846 14.5362L41.4118 15.1255C41.5599 15.2092 41.5599 15.425 41.4118 15.5087L40.3846 16.098L39.3541 16.6905C39.206 16.7742 39.0225 16.6679 39.0225 16.4973V16.3266C39.0225 15.4636 38.0886 14.9226 37.3416 15.3541L36.2113 16.0014L35.0971 16.639C34.3469 17.0705 34.3469 18.1556 35.0971 18.5871L36.2113 19.2247L37.3416 19.872C38.0886 20.3002 39.0225 19.7625 39.0225 18.8995V18.7546C39.0225 18.6741 38.9806 18.6 38.9098 18.5614L38.3849 18.2619C38.24 18.1782 38.0596 18.2844 38.0596 18.4519V18.7964C38.0596 18.9671 37.8761 19.0734 37.728 18.9896L36.6975 18.3971L35.6703 17.8079C35.5222 17.7241 35.5222 17.5084 35.6703 17.4247L36.6975 16.8354L37.728 16.2429C37.8761 16.1592 38.0596 16.2654 38.0596 16.4361V16.6068C38.0596 17.4698 38.9935 18.0107 39.7405 17.5792L40.8708 16.932L41.985 16.2944C42.7352 15.8597 42.7352 14.7777 41.985 14.3462Z"
        fill="black"
      />
      <path
        d="M34.6753 14.5588L32.067 19.9461H30.985L31.9607 17.9335L30.4247 14.5588H31.5357L32.521 16.8194L33.5966 14.5588H34.6753Z"
        fill="black"
      />
      <path
        d="M8.59562 16.4717C8.59562 15.8277 8.1287 15.3769 7.55552 15.3769C6.98234 15.3769 6.51543 15.8373 6.51543 16.4717C6.51543 17.0996 6.98234 17.5665 7.55552 17.5665C8.1287 17.5665 8.59562 17.1157 8.59562 16.4717ZM8.60528 18.3844V17.8886C8.32191 18.2331 7.90007 18.4456 7.39774 18.4456C6.34798 18.4456 5.55261 17.6052 5.55261 16.4717C5.55261 15.3479 6.38018 14.4913 7.42028 14.4913C7.90973 14.4913 8.32191 14.7071 8.60528 15.042V14.559H9.54555V18.3844H8.60528Z"
        fill="black"
      />
      <path
        d="M14.1181 17.5343C13.7896 17.5343 13.6962 17.4119 13.6962 17.0899V15.3929H14.3016V14.5589H13.6962V13.625H12.7334V14.5589H11.4905V14.1789C11.4905 13.8569 11.6128 13.7345 11.9509 13.7345H12.1635V12.9939H11.6998C10.9044 12.9939 10.5276 13.2547 10.5276 14.0501V14.5621H9.9931V15.3929H10.5276V18.3844H11.4905V15.3929H12.7334V17.267C12.7334 18.0463 13.0329 18.3844 13.8122 18.3844H14.3081V17.5343H14.1181Z"
        fill="black"
      />
      <path
        d="M17.5765 16.1271C17.5089 15.6312 17.1032 15.3317 16.6266 15.3317C16.1532 15.3317 15.7604 15.6215 15.6638 16.1271H17.5765ZM15.6541 16.7228C15.7217 17.2895 16.1275 17.6115 16.6427 17.6115C17.0484 17.6115 17.3608 17.4216 17.5443 17.1156H18.5329C18.3043 17.9271 17.5765 18.4456 16.6201 18.4456C15.4641 18.4456 14.6526 17.6341 14.6526 16.4781C14.6526 15.322 15.5092 14.488 16.6427 14.488C17.7826 14.488 18.6102 15.3285 18.6102 16.4781C18.6102 16.5618 18.6037 16.6455 18.5876 16.7228H15.6541Z"
        fill="black"
      />
      <path
        d="M24.7412 16.4716C24.7412 15.8534 24.2743 15.3768 23.7011 15.3768C23.1279 15.3768 22.661 15.8373 22.661 16.4716C22.661 17.0995 23.1279 17.5665 23.7011 17.5665C24.2743 17.5665 24.7412 17.0931 24.7412 16.4716ZM21.7111 19.9461V14.5589H22.6513V15.0548C22.9347 14.7038 23.3565 14.488 23.8589 14.488C24.8925 14.488 25.704 15.3381 25.704 16.462C25.704 17.5858 24.8764 18.4423 23.8363 18.4423C23.3533 18.4423 22.9572 18.2523 22.6803 17.9303V19.9429H21.7111V19.9461Z"
        fill="black"
      />
      <path
        d="M29.0948 16.4717C29.0948 15.8277 28.6279 15.3769 28.0547 15.3769C27.4815 15.3769 27.0146 15.8373 27.0146 16.4717C27.0146 17.0996 27.4815 17.5665 28.0547 17.5665C28.6279 17.5665 29.0948 17.1157 29.0948 16.4717ZM29.1045 18.3844V17.8886C28.8211 18.2331 28.3993 18.4456 27.8969 18.4456C26.8472 18.4456 26.0518 17.6052 26.0518 16.4717C26.0518 15.3479 26.8794 14.4913 27.9195 14.4913C28.4089 14.4913 28.8211 14.7071 29.1045 15.042V14.559H30.0448V18.3844H29.1045Z"
        fill="black"
      />
      <path
        d="M20.0141 14.9324C20.0141 14.9324 20.2524 14.488 20.8417 14.488C21.0928 14.488 21.2539 14.575 21.2539 14.575V15.5507C21.2539 15.5507 20.8996 15.3317 20.5744 15.3768C20.2492 15.4219 20.0431 15.7181 20.0431 16.1174V18.3812H19.0706V14.5589H20.0109V14.9324H20.0141Z"
        fill="black"
      />
    </CustomSvg>
  )
}

const CustomSvg = styled.svg`
  height: 32px;
  min-height: 32px;
  min-width: 48px;
  width: 48px;
`
